'use client';

import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/autoplay";

import { Swiper } from 'swiper/react';
import { Navigation, Autoplay  } from 'swiper/modules';
import { useRef, useEffect, useState, ReactNode } from 'react';

type Props = {
    title?: string;
    icon?: string;
    titleUrl: string;
    perView?: number | "auto";
    children: ReactNode; 
    breakpoints?: Record<number, { slidesPerView: number }>; 
};

export default function Slider({ title, icon, titleUrl, perView, children, breakpoints }: Props) {
    const prevRef = useRef<HTMLDivElement | null>(null);
    const nextRef = useRef<HTMLDivElement | null>(null);
    const [navigationReady, setNavigationReady] = useState(false);

    useEffect(() => {
        setNavigationReady(true);
    }, []);

    return (
        <div className={`slider-wrapper`}>
        {/* <div ref={prevRef} className={'swiper-button-prev'} />
        <div ref={nextRef} className={'swiper-button-next'} /> */}

        {title && (
            // <div className={styles.sliderHeader}>
            //     <div>
            //         <a href={""}>
            //         <i className={`icon-${icon} icons ${styles.slideIconImage} icon`}></i>
            //         {title}
            //         </a>
            //     </div>
            // </div>
            <></>
        )}

        <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
            const nav = swiper.params.navigation;
            if (nav && typeof nav !== 'boolean') {
                nav.prevEl = prevRef.current;
                nav.nextEl = nextRef.current;
            }
            }}
            loop={true}
            spaceBetween={3.5}
            slidesPerView={perView ?? 'auto'}
            centeredSlides={false}
            slideToClickedSlide={false}
            breakpoints={breakpoints}
            // autoplay={{
            //     delay: 3000,                 // 자동 전환
            //     disableOnInteraction: false, // 터치해도 자동재생 유지
            //     pauseOnMouseEnter: true,     // 마우스 올리면 멈춤
            // }}
            >

            {children}
            
        </Swiper>
        </div>
  );
}
